'use client';

import Navbar from '@/components/navbar';
import Footer from '@/components/footer';
import { Toaster } from "@/components/ui/toaster";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from 'react';
import { useToast } from '@/hooks/use-toast';
import Link from 'next/link';

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname();
  const { toast } = useToast();
  const toastRef = useRef<{ id: string; dismiss: () => void } | null>(null);

  const hideHeaderFooterPaths = [
    "/auth/signin",
    "/auth/signup",
  ];
  
  const showHeaderFooter = !hideHeaderFooterPaths.includes(pathname || "");

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      toastRef.current = toast({
        description: (
          <div className="flex flex-col items-center justify-center w-full">
            <h2 className="text-white text-xl font-semibold mb-4 text-center">Cookie Usage</h2>
            <p className="text-white mb-4 text-center">
              We use mandatory cookies to provide the content of our website and for certain functions to work. With your explicit consent, optional cookies may be used to improve your experience, to carry out marketing activities specific to you, to make the site functional and to analyze performance. Non-essential cookies will not be used without your consent. For detailed information, you can review our{' '}
              <Link href="/legal/cookie-policy" className="text-emerald-500 hover:underline">
                cookie policy
              </Link>.
            </p>
            <div className="flex space-x-4 justify-center">
              <button
                onClick={() => {
                  localStorage.setItem('cookieConsent', 'rejected');
                  if (toastRef.current) toastRef.current.dismiss();
                }}
                className="bg-black text-white border border-white/10 rounded-lg px-4 py-2 hover:bg-white/10 transition"
              >
                Reject
              </button>
              <button
                onClick={() => {
                  localStorage.setItem('cookieConsent', 'accepted');
                  if (toastRef.current) toastRef.current.dismiss();
                }}
                className="bg-emerald-500 text-white rounded-lg px-4 py-2 hover:bg-emerald-600 transition"
              >
                Accept
              </button>
            </div>
          </div>
        ),
        duration: Infinity,
        className: "fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-black text-white p-6 rounded-lg shadow-lg z-50 w-11/12 max-w-6xl",
      });
    }
  }, [toast]);

  return (
    <>
      {showHeaderFooter && <Navbar />}
      <main>{children}</main>
      {showHeaderFooter && <Footer />}
      <Toaster />
    </>
  );
}